import React from "react";

// Barra di avanzamento upload: progress = { pct: 0..100, name }
export default function UploadProgress({ progress }) {
  if (!progress) return null;
  return (
    <div data-testid="upload-progress" className="rounded-lg border border-slate-200 bg-white px-3 py-2">
      <div className="flex items-center justify-between text-xs text-slate-600 mb-1">
        <span className="truncate pr-2">Caricamento{progress.name ? `: ${progress.name}` : ""}</span>
        <span className="font-semibold tabular-nums">{progress.pct}%</span>
      </div>
      <div className="h-2 w-full rounded-full bg-slate-100 overflow-hidden">
        <div className="h-full bg-teal-600 transition-[width] duration-200" style={{ width: `${progress.pct}%` }} />
      </div>
      <p className="text-[11px] text-slate-400 mt-1">Non chiudere la pagina: i file pesanti vengono inviati a blocchi.</p>
    </div>
  );
}
